/**
 * Prepopulation Default props used by all containers that consumes
 * the group-routes && aggregation MS enpoints.
 *
 * ----------- Containers using it --------
 *
 * - FareListContainer
 * - FaresCarouselBackgroundImageContainer
 * - FaresCarouselBackgroundImageContainerMobile
 * - FaresGridBackgroundImage
 * - FaresGridBackgroundImageMobile
 * - FeaturedDestinationContainer
 * - FeaturedDestinationContainerMobile
 */

import airportParams from './airports';

export default {
  siteEdition: '',
  airlineIataCode: 'ua',
  dataExpirationWindow: '1d',
  datePattern: 'MM/dd/yy',
  departure: { start: 0, end: 45 },
  origins: [],
  destinations: [],
  faresPerRoute: 1,
  flightType: 'ROUND_TRIP',
  languageCode: 'en',
  outputCurrencies: [],
  faresLimit: 11,
  page: 1,
  outputFields: [
    'returnDate',
    'currencySymbol',
    'currencyCode',
    'usdTotalPrice',
    'popularity',
    'originCity',
    'destinationCity',
    'destinationAirportImage',
    'destinationCityImage',
    'destinationStateImage',
    'destinationCountryImage',
    'destinationRegionImage',
    'farenetTravelClass',
    'travelClass',
    'flightDeltaDays',
    'flightType',
  ],
  budget: { maximum: null },
  markets: [],
  airport: { ...airportParams },
  priceFormat: { decimalSeparator: '.', thousandSeparator: ',', decimalPlaces: 0 },
  routesLimit: 11,
  sorting: [{ popularity: 'DESC' }, { usdTotalPrice: 'ASC' }],
  currencyPricingSettings: [
    {
      currencyCode: 'USD',
      priceFormat: {
        decimalSeparator: '.',
        thousandSeparator: ',',
      },
    },
  ],
};
